import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const fill = keyframes`
  to {
    fill: url(#d);
    stroke-dashoffset: 0;
  }
`;

// export const ShadowContainer = styled.div`
//   position: absolute;

//   animation: ${ping} 1s alternate infinite;
//   box-shadow: -5px -5px 80px 20px #4e67cf;
//   border-radius: 22%;
// `;

export const LogoSVG = styled.svg`
  & .e {
    fill: url(#d);
  }

  & #tail {
    stroke: url(#d);
    stroke-width: 2;
    fill: transparent;
    stroke-dasharray: 700;
    stroke-dashoffset: 700;
    animation: ${fill} 1.5s ease-in-out infinite alternate-reverse;
  }

  & #circle {
    stroke: #fff;
    stroke-width: 2;
    fill: #fff;
    stroke-dasharray: 700;
    stroke-dashoffset: 700;
  }
`;

// @keyframes zentit {
//   to {
//     fill: url(#d);
//     stroke-dashoffset: 0;
//   }
// }

// @keyframes circle {
//   to {
//     /* fill: #fff; */
//     stroke-dashoffset: 0;
//   }
// }

export interface StudioProps {}

export const AppLoader = ({
  message,
  version,
}: {
  message: string;
  version: string;
}) => {
  return (
    <div className="absolute inset-0 flex h-screen w-screen flex-col items-center justify-center bg-fd-gray-default text-white">
      <div className="flex flex-col text-center">
        <div className="relative mr-4 self-center">
          {/* <img src={logo} alt="4D" className="inline-block w-20 h-20" /> */}
          {/* <ShadowContainer className="inset-0"></ShadowContainer> */}
          <div className="flex items-center justify-center rounded">
            <LogoSVG className="h-60 w-60" viewBox="0 0 143.14 136.27">
              <defs>
                <linearGradient id="d" x1="50%" y1="0%" x2="50%" y2="100%">
                  <stop offset="0%" stopColor="#2743a6">
                    <animate
                      attributeName="stop-color"
                      values="#ffa4c0; #2743a6;"
                      dur="6s"
                      repeatCount="indefinite"
                    ></animate>
                  </stop>

                  <stop offset="100%" stopColor="#ffa4c0">
                    <animate
                      attributeName="stop-color"
                      values="#2743a6; #ffa4c0;"
                      dur="2ds"
                      repeatCount="indefinite"
                    ></animate>
                  </stop>
                </linearGradient>
              </defs>
              <g id="a" />
              <g id="b">
                <g id="c">
                  <g>
                    <path
                      id="tail"
                      className="e"
                      d="M134.13,79.9l.25-1.2h-21.87l-.21,.7c-.03,.08-2.41,7.72-7.11,14.56-5.87,8.54-12.57,12.63-12.63,12.67l-1,.6,24.25,28.96h27.33l-22.61-26.46c2.2-2.67,10.06-13.09,13.6-29.83Z"
                    />
                    <path
                      id="circle"
                      className="f"
                      d="M83.08,113.64l18.93,22.6-33.68,.03-11.17-.03c-9.38,.01-18.55-2.45-26.56-7.11-2.94-1.71-5.72-3.71-8.29-6-8.79-7.8-17.6-19.72-20.92-37.37-.01-.02-.02-.03-.03-.05v-.09c-1.68-9.04-1.93-19.58,0-31.84C8.57,21.67,36.68-.66,69.93,.02c12.81,.27,25.06,4.28,35.59,11.48,.31,.2,.62,.41,.92,.62,.25,.18,.5,.35,.74,.53,8.82,6.31,16.06,14.69,21.02,24.42,.17,.33,.34,.65,.5,.98,.1,.21,.2,.41,.3,.61,4.35,8.92,6.63,18.54,6.54,28.06,0,.36,.02,.71,.02,1.06,0,.82-.03,1.62-.06,2.43h-22c.04-.81,.06-1.61,.06-2.43,0-1.52-.08-3.02-.23-4.5-2.68-22.17-21.26-39.86-43.98-40.63-4.43-.15-8.75,.29-12.88,1.28-.02,0-.04,.01-.05,.01-.48,.12-.95,.24-1.42,.38-.97,.26-1.94,.56-2.89,.9-.23,.07-.46,.15-.69,.24-6.2,2.27-11.84,5.87-16.59,10.67-8.99,9.09-13.84,21.44-13.3,33.9,0,19.98,17.86,39.48,35.59,42.56,6.4,1.37,24.04,1.24,25.96,1.05Z"
                    />
                  </g>
                </g>
              </g>
            </LogoSVG>
          </div>
        </div>
        <div>
          <span className="text-xs text-grey-200">{version}</span>
          <h2 className="text-lg text-grey-100">{message}</h2>
        </div>
      </div>
    </div>
  );
};
